var stateInput = input;
var stateFilter = filter;
var statePage = currentPage;
var AddFilterTag = true,
  tagAdd = false;

function filterHover(id, colour) {
  document.getElementById(id).style.backgroundColor = hexToRGB(colour, 0.25);
}
function filterOut(id) {
  document.getElementById(id).style.backgroundColor = "#e5e5e5";
}
function removeBorder(id) {
  id.style.border = `2px solid transparent`;
  
}
function filterSelected(id) {
  const PageBtn = document.getElementById("articles");
  AddFilterTag = true;
  PageBtn.innerHTML = "";
  if (stateInput != "" && stateInput != " ") {
    document.getElementsByClassName("recommendationBarDiv")[0].style.display =
      "none";
    document.getElementsByClassName(
      "searchBarContainer"
    )[0].style.backgroundColor = "transparent";
    document.getElementById("blogSearchBar").value = "";
    document.getElementsByClassName("searchClearIcon")[0].style.display =
      "none";
  }
  stateInput = "";
  var filteredArray = [];
  var filters = document.getElementsByClassName("filter_tag");
  for (let i = 0; i < filters.length; i++) {
    filters[i].style.backgroundColor = "#e5e5e5";
    removeBorder(filters[i]);
    filters[i].style.boxShadow = "none";
    filters[i].href = "/blogs/health?filter=" + filters[i].id;
  }
  filters[0].onmouseout = function () {
    filterOut(filters[0].id);
    
  };
  filters[1].onmouseout = function () {
    filterOut(filters[1].id);
  };
  filters[2].onmouseout = function () {
    filterOut(filters[2].id);
  };
  filters[3].onmouseout = function () {
    filterOut(filters[3].id);
  };
  filters[4].onmouseout = function () {
    filterOut(filters[4].id);
  };
  filters[5].onmouseout = function () {
    filterOut(filters[5].id);
  };
  filters[6].onmouseout = function () {
    filterOut(filters[6].id);
  };
  filters[7].onmouseout = function () {
    filterOut(filters[7].id);
  };
  var tagName =
    "_related:" +
    id
      .replace(/%20/g, "-")
      .replace(/ /g, "-")
      .replace(/%27/g, "'")
      .replace(/%26/g, "&")
      .toLowerCase();
  var filter = document.getElementById(id);
  if (filter != null && filter != undefined) {
    AddFilterTag = false;
    var customFilter = document.getElementById("custom");
    if (!customFilter.classList.contains("hidden-tag")) {
      customFilter.classList.add("hidden-tag");
    }
    if (stateFilter != id) {
      stateFilter = id;
      //var filterColour = filter.getElementsByTagName('span')[0].style.color;
      var filterColour = filter.dataset.color;
      filter.style.border = `2px solid ${filterColour}`;
     // filter.style.backgroundColor = hexToRGB(filterColour, 0.25); //filterColour.replace(')', ', 0.25)').replace('rgb', 'rgba');
      filter.style.boxShadow = "0px 5px 10px rgba(0, 0, 0, 0.25)";
     // filter.onmouseout = null;
      filter.href = "/blogs/health";
    } else {
      tagName = "";
      stateFilter = "";
      AddFilterTag = true;
      filter.style.border = `2px solid transparent`;
      filter.style.backgroundColor = "#e5e5e5";
      filter.style.boxShadow = "none";
      clearsearchfilter();
      filter.onmouseout = function () {
        filterOut(filter.id);
      };
      filter.href = "/blogs/health?filter=" + filter.id;
    }
  } else {
    AddFilterTag = false;
    var customTag = document.getElementById("custom-tag-text").innerText;
    if (customTag == "" || customTag == null) {
      customTag = id;
    }
    tagName =
      "_related:" +
      customTag
        .replace(/%20/g, "-")
        .replace(/ /g, "-")
        .replace(/%27/g, "'")
        .replace(/%26/g, "&")
        .toLowerCase();
    var filter = document.getElementById("custom");
    var filterColour = "";
    var colourIndex = tagNames.indexOf(tagName);
    if (colourIndex != -1) {
      filterColour = tagColours[colourIndex];
    } else {
      var randomColourIndex = extraTags.indexOf(tagName);
      filterColour = randomColours[randomColourIndex];
    }
    var filterText = id
      .replace(/%20/g, " ")
      .replace(/%27/g, "'")
      .replace(/%26/g, "&");

    var filterColourAlpha = hexToRGB(filterColour, 0.25);
   // filter.getElementsByTagName("span")[0].style.color = filterColour;
    document.getElementById("custom-tag-text").innerText = filterText;
     
    stateFilter = id;
    if (filter.classList.contains("hidden-tag")) {
      filter.classList.remove("hidden-tag");
    }
    filter.classList.remove("hidden-tag");
    filter.style.border = `2px solid ${filterColour}`;
    filter.style.boxShadow = "0px 5px 10px rgba(0, 0, 0, 0.25)";
   filter.onmouseover = function(){
      filterHover('custom', filterColour);
    };
    filter.onmouseout = function(){
      filterOut('custom');
    };
    filter.href = "/blogs/health";
  }
  currentPage = 1;
  statePage = currentPage;
  for (let j = 0; j < articlesArray.length; j++) {
    if (articlesArray[j].tags.includes(tagName) || tagName == "") {
      filteredArray.push(articlesArray[j]);
    }
  }
    
  if (AddFilterTag == false) {
    filteredArray.sort(function (a, b) {
      return b["updated"] - a["updated"];
    });
  }
  blogDisplayArticles(filteredArray);
  var stateObj = {
    searchParams: stateInput,
    filter: stateFilter,
    page: statePage,
  };
  history.pushState(stateObj, "Illuminate Health");
  return false;
}
function noFilter() {
  var filters = document.getElementsByClassName("filter_tag");
  AddFilterTag = true;
  for (let i = 0; i < filters.length; i++) {
    filters[i].style.backgroundColor = "#e5e5e5";
    removeBorder(filters[i]);
    filters[i].style.boxShadow = "none";
    filters[i].href = "/blogs/health?filter=" + filters[i].id;
  }
  filters[0].onmouseout = function () {
    filterOut(filters[0].id);
  };
  filters[1].onmouseout = function () {
    filterOut(filters[1].id);
  };
  filters[2].onmouseout = function () {
    filterOut(filters[2].id);
  };
  filters[3].onmouseout = function () {
    filterOut(filters[3].id);
  };
  filters[4].onmouseout = function () {
    filterOut(filters[4].id);
  };
  filters[5].onmouseout = function () {
    filterOut(filters[5].id);
  };
  filters[6].onmouseout = function () {
    filterOut(filters[6].id);
  };
  filters[7].onmouseout = function () {
    filterOut(filters[7].id);
  };
  var customFilter = document.getElementById("custom");
  if (!customFilter.classList.contains("hidden-tag")) {
    customFilter.classList.add("hidden-tag");
  }
  stateFilter = "";
}
function removeCustomFilter() {
  const PageBtn = document.getElementById("articles");
  PageBtn.innerHTML = "";
  var customFilter = document.getElementById("custom");
  if (!customFilter.classList.contains("hidden-tag")) {
    clearSearchInput();
    customFilter.classList.add("hidden-tag");
  }
  stateFilter = "";
  stateInput = "";
  currentPage = 1;
  statePage = currentPage;
  // blogDisplayArticles(articlesArray);
  var stateObj = {
    searchParams: stateInput,
    filter: stateFilter,
    page: statePage,
  };
  history.replaceState(stateObj, "Illuminate Health");
  return false;
}
function hexToRGB(hex, alpha) {
  var r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
  } else {
    return "rgb(" + r + ", " + g + ", " + b + ")";
  }
}
function blogSearch() {
  const PageBtn = document.getElementById("articles");
  PageBtn.innerHTML = "";
  AddFilterTag = true;
  var searchField = document.getElementById("blogSearchBar");
  input = searchField.value.toUpperCase();
  stateInput = input;
  if (stateFilter != "") {
    noFilter();
  }
  currentPage = 1;
  statePage = currentPage;
  stateFilter = "";
  var filteredArray = [];
  var filteredTitleArray = [];
  var filteredContentArray = [];
  var filteredTags = [];

  var searchPrompt = document.getElementById("blogSearchPrompt");
  document.getElementsByClassName("recommendationBarDiv")[0].style.display =
    "none";
  document.getElementsByClassName(
    "searchBarContainer"
  )[0].style.backgroundColor = "transparent";
  document.getElementsByClassName("searchClearIcon")[0].style.display = "block";

  if (input != "" && input != " ") {
    
    for (let i = 0; i < articlesArray.length; i++) {
      filteredTags.push(...articlesArray[i].tags);
      var articleName = articlesArray[i].title;
      
      var articleContent = purgeArticleContent(articlesArray[i].content)
        ? purgeArticleContent(articlesArray[i].content)
        : articlesArray[i].content_trunc;
      var articleTags = articlesArray[i].tags;
      var matchIndex = articleTags.findIndex((element) => {
        var elementTag = element
          .toUpperCase()
          .replace("_related:", "")
          .replace("-", " ");
        if (elementTag.indexOf(input) > -1) {
          return true;
        }
      });
      if (articleName.toUpperCase().indexOf(input) > -1) {
        var thisArticle = JSON.parse(JSON.stringify(articlesArray[i]));
        thisArticle.content_trunc = articleContent;
        filteredTitleArray.push(thisArticle);
      } else if (
        articleContent.toUpperCase().indexOf(input) > -1 ||
        matchIndex > -1
      ) {
        var thisArticle = JSON.parse(JSON.stringify(articlesArray[i]));
        thisArticle.content_trunc = articleContent;
        filteredContentArray.push(thisArticle);
      }
    }
    filteredContentArray.sort(function (a, b) {
      return b["updated"] - a["updated"];
    });
    filteredTitleArray.sort(function (a, b) {
      return b["updated"] - a["updated"];
    });

    filteredArray = filteredTitleArray.concat(filteredContentArray);

    var uniqueTags = [...new Set(filteredTags)];
    for (let i = 0; i < uniqueTags.length; i++) {
      var tag = uniqueTags[i];
      var tagName = tag.replace("_related:", "");
      var words = tagName.split("-");
      for (let j = 0; j < words.length; j++) {
        words[j] = words[j][0].toUpperCase() + words[j].substr(1);
      }
      if (words[0].includes("nti")) {
        tagName = words.join("-");
      } else {
        tagName = words.join(" ");
      }

      if (
        tagName.toUpperCase().startsWith(input) &&
        tagName.toUpperCase().indexOf(input) > -1 &&
        tagName.toUpperCase() != input
      ) {
        searchPrompt.value = tagName;
        document.getElementsByClassName(
          "recommendationBarDiv"
        )[0].style.display = "flex";
        document.getElementsByClassName(
          "searchBarContainer"
        )[0].style.backgroundColor = "#e5e5e5";
      }
    }
    //
    var stateObj = {
      searchParams: stateInput,
      filter: stateFilter,
      page: statePage,
    };
    history.replaceState(stateObj, "Illuminate Health");
    filter = history.state.filter;
    pageChangeSearch();
    //  blogDisplayArticles(filteredArray, input);
  } else {
    blogDisplayArticles(articlesArray);
    document.getElementsByClassName("searchClearIcon")[0].style.display =
      "none";
  }

  var stateObj = {
    searchParams: stateInput,
    filter: stateFilter,
    page: statePage,
  };
  history.replaceState(stateObj, "Illuminate Health");
}
function blogSearchPrompt() {
  const PageBtn = document.getElementById("articles");
  PageBtn.innerHTML = "";
  var searchPrompt = document.getElementById("blogSearchPrompt");
  document.getElementsByClassName("searchClearIcon")[0].style.display = "block";
  input = searchPrompt.value.toUpperCase();
  stateInput = "";
  if (stateFilter != "") {
    noFilter();
  }
  currentPage = 1;
  statePage = currentPage;
  stateFilter = searchPrompt.value;

  var filteredArray = [];
  var filteredTags = [];
  var searchField = document.getElementById("blogSearchBar");
  searchField.value = "";
 // searchField.value = searchPrompt.value;
  PageBtn.innerHTML = "";
  document.getElementsByClassName("recommendationBarDiv")[0].style.display =
    "none";
  document.getElementsByClassName(
    "searchBarContainer"
  )[0].style.backgroundColor = "transparent";
  for (let i = 0; i < articlesArray.length; i++) {
    filteredTags.push(...articlesArray[i].tags);
    var articleName = articlesArray[i].title;
    var articleContent = purgeArticleContent(articlesArray[i].content)
      ? purgeArticleContent(articlesArray[i].content)
      : articlesArray[i].content_trunc;
    var articleTags = articlesArray[i].tags;
    var matchIndex = articleTags.findIndex((element) => {
      var elementTag = element
        .toUpperCase()
        .replace("_related:", "")
        .replace("-", " ");
      if (elementTag.indexOf(input) > -1) {
        return true;
      }
    });
    if (matchIndex > -1) {
      var thisArticle = JSON.parse(JSON.stringify(articlesArray[i]));
      thisArticle.content_trunc = articleContent;
      if (filteredArray.includes(thisArticle)) {
        console.log("Exist");
      } else {
        filteredArray.push(thisArticle);
      }
    }
  }
  filteredArray.sort(function (a, b) {
    return b["updated"] - a["updated"];
  });

  var stateObj = {
    searchParams: stateInput,
    filter: stateFilter,
    page: statePage,
  };
  history.replaceState(stateObj, "Illuminate Health");
  filter = history.state.filter;
  AddFilterTag = false;
  tagAdd = true;
  pageChangeSearch();
  // window.scrollTo({top: 0, behavior: 'smooth'});
  return false;
  // blogDisplayArticles(filteredArray, input);
}
function blogDisplayArticles(displayArray, searchTerm) {
  const PageBtn = document.getElementById("articles");
  const PageFilter = document.getElementById("articlesFilter");
  const PageNoFilter = document.getElementById("articlesNoFilter");
  var htmlContent = "";
  var articlesLength = displayArray.length;
  var articlesPageLength = 5;
  var maxPages = Math.ceil(articlesLength / articlesPageLength);
  var iteratePages = maxPages + 1;
  var currentPageNum = parseInt(currentPage);

  if (articlesLength == 0) {
    PageNoFilter.innerHTML =
      "<h2 class='text-center filters-text'>No results</h2>";
    PageFilter.style.display = "none";
    document.getElementById("custom-paginate").innerHTML = "";
  } else {
    PageNoFilter.innerHTML = "";
    if (searchTerm != undefined) {
      PageFilter.style.display = "none";
    } else {
      PageFilter.style.display = "grid";
    }
    if (articlesLength <= articlesPageLength) {
      document.getElementById("custom-paginate").innerHTML = "";
      for (let i = 0; i < articlesLength; i++) {
        element = displayArray[i];
        htmlContent =
          '<div class="feature-row" style="justify-content: center;">';
        htmlContent = htmlContent + '<div class="card">';
        htmlContent =
          htmlContent + '<a class="top-link" href="' + element.url + '"></a>';
        if (element.image != "") {
          htmlContent =
            htmlContent +
            '<a class=" article__featured-image-link-img" href="' +
            element.url +
            '"><img class="lazyload" src="' +
            element.img_src +
            '" data-src="' +
            element.img_url +
            '" data-widths="[360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="' +
            element.img_aspect +
            '" data-sizes="auto" alt="' +
            element.title_esc +
            '"></a>';
        }
        var GetDate = element.published_long;
        if (searchTerm != null && searchTerm != "" && searchTerm != " ") {
          GetDate = element.updated_long;
        }
        if (AddFilterTag == false) {
          GetDate = element.updated_long;
        }
        htmlContent =
          htmlContent +
          '<div class="date-wrap"><time datetime="' +
          element.published +
          '" class="date">' +
          GetDate +
          '</time>'+
          (element.sponsored_article == "true" ? "<span class='sponsored'>Sponsored</span>" : '') +
          '</div><div class="content-wrap"><h2 class="h3"><a class="article__heading-link" href="' +
          element.url +
          '">' +
          element.title +
          '</a></h2><div class="rte rte--indented-images">' +
          element.content_trunc +
          "</div></div>";

        htmlContent = htmlContent + "</div></div>";
        const newArt = document.createElement("article");
        newArt.setAttribute("id", "article" + String(i + 5));
        newArt.classList.add("article");
        newArt.classList.add("margin");
        newArt.classList.add("small--text-center");
        PageBtn.append(newArt);
        newArt.innerHTML = htmlContent;
        if (searchTerm != null && searchTerm != "" && searchTerm != " ") {
          highlightText(
            searchTerm,
            newArt.getElementsByClassName("rte--indented-images")[0]
          );
          highlightText(
            searchTerm,
            newArt.getElementsByClassName("h3")[0],
            "title"
          );
        }
      }
    } else {
      var firstArticle = (currentPageNum - 1) * articlesPageLength;
      var lastArticle = Math.min(firstArticle + 5, articlesLength);

      for (let i = firstArticle; i < lastArticle; i++) {
        element = displayArray[i];
        htmlContent =
          '<div class="feature-row" style="justify-content: center;">';
        htmlContent = htmlContent + '<div class="card">';
        htmlContent =
          htmlContent + '<a class="top-link" href="' + element.url + '"></a>';
        if (element.image != "") {
          htmlContent =
            htmlContent +
            '<a class="article__featured-image-link test article__featured-image-link-img" href="' +
            element.url +
            '"><img class="lazyload" src="' +
            element.img_src +
            '" data-src="' +
            element.img_url +
            '" data-widths="[1080, 1296, 1512, 1728, 2048]" data-aspectratio="' +
            element.img_aspect +
            '" data-sizes="auto" alt="' +
            element.title_esc +
            '"></a>';
        }
        var GetDate = element.published_long;
        if (searchTerm != null && searchTerm != "" && searchTerm != " ") {
          GetDate = element.updated_long;
        }

        if (AddFilterTag == false) {
          GetDate = element.updated_long;
        }
        htmlContent =
          htmlContent +
          '<div class="date-wrap"><time datetime="' +
          element.published +
          '" class="date">' +
          GetDate +
          '</time></div><div class="content-wrap"><h2 class="h3"><a class="article__heading-link" href="' +
          element.url +
          '">' +
          element.title +
          '</a></h2><div class="rte rte--indented-images">' +
          element.content_trunc +
          "</div></div>";
        htmlContent = htmlContent + "</div></div>";
        const newArt = document.createElement("article");
        newArt.setAttribute("id", "article" + String(i + 5));
        newArt.classList.add("article");
        newArt.classList.add("margin");
        newArt.classList.add("small--text-center");
        PageBtn.append(newArt);
        newArt.innerHTML = htmlContent;
        if (searchTerm != null && searchTerm != "" && searchTerm != " ") {
          highlightText(
            searchTerm,
              newArt.getElementsByClassName("rte--indented-images")[0]
          );
          highlightText(
            searchTerm,
              newArt.getElementsByClassName("h3")[0],
            "title"
          );
        }
      }

      var urlString = "/blogs/health?";
      htmlContent = "";
      if (currentPageNum != maxPages) {
        urlString = "/blogs/health?";
        if (filter != "" && filter != null) {
          urlString = urlString + "filter=" + filter + "&";
        }
        urlString = urlString + "pages=" + String(currentPageNum + 1);

        //   htmlContent = htmlContent+'<span class="next"><a href="'+urlString+'" title="" onclick="return pushHistoryState('+String(currentPageNum+1)+');"><span class="icon-fallback-text"><span class="icon icon-arrow-right" aria-hidden="true"></span><span class="fallback-text">Next</span></span></a></span>';

        htmlContent =
          htmlContent +
          '<br/><div class="text-center"><a href="' +
          urlString +
          '" onclick="return pushHistoryState(' +
          String(currentPageNum + 1) +
          ');" class="btn article__cta" style="color: #ffffff; background-color: #222323; font-size: 1.4em;">More Articles</a></div>';
      }
      document.getElementById("custom-paginate").innerHTML = htmlContent;
    }
  }
}

function purgeArticleContent(content) {
  var purgedContent = "";

  if (content.toUpperCase().indexOf(input) > -1) {
    var contentSections = content.split("<script>");
    for (let j = 0; j < contentSections.length; j++) {
      var scriptIndex = contentSections[j].indexOf("</script>");
      if (scriptIndex > -1) {
        var contentString = contentSections[j].slice(scriptIndex);
        contentSections[j] = contentString.replace(/(<([^>]+)>)/gi, "");
      }
    }

    purgedContent = contentSections.join("");

    var matchIndex = purgedContent.toUpperCase().indexOf(input);
    var beforeMatch = purgedContent.substring(0, matchIndex);
    var afterMatch = purgedContent.substring(matchIndex);
    var paragraphStart = beforeMatch.split(".");
    for (let k = 0; k < paragraphStart.length; k++) {
      if (paragraphStart[k].length < 1 || paragraphStart[k] == " ") {
        paragraphStart.splice(k, 1);
        k--;
      }
    }
    var paragraphEnd = afterMatch.split(".");
    for (let l = 0; l < paragraphEnd.length; l++) {
      if (paragraphEnd[l].length < 1 || paragraphStart[l] == " ") {
        paragraphEnd.splice(l, 1);
        l--;
      }
    }

    purgedContent = paragraphStart[paragraphStart.length - 1];
    var maxParagraphs = Math.min(paragraphEnd.length, 1);
    purgedContent = purgedContent == undefined ? "" : purgedContent;
    for (let m = 0; m < maxParagraphs; m++) {
      purgedContent = purgedContent + paragraphEnd[m] + "\n";
    }

    var purgedArray = purgedContent.split(" ");
    if (purgedArray.length > 80) {
      purgedArray = purgedArray.splice(0, 79);
      purgedContent = purgedArray.join(" ");
      var dotsArray = purgedContent.split(".");
      dotsArray = dotsArray.splice(0, dotsArray.length - 1);
      purgedContent = dotsArray.join(".") + ".";
    } else {
      purgedContent = purgedArray.join(" ");
      purgedContent = purgedContent.trim() + ".";
    }
  }
  return purgedContent;
}
function highlightText(searchTerm, article, title ="none") {
  // var article = document.getElementById("article"+String(i)).getElementsByClassName("rte--indented-images")[0];
  if (article) {
    var innerHTML = article.innerHTML
    
    if(title != "none"){
     innerHTML = article.textContent;
    }
    var lastIndex = 0;
    var loops = 0;
    var newInnerHTML = "";
    do {
      var index = innerHTML
        .toUpperCase()
        .substring(lastIndex, innerHTML.length)
        .indexOf(searchTerm);
      if (index > -1) {
        newInnerHTML =
          newInnerHTML +
          innerHTML.substring(lastIndex, lastIndex + index) +
          "<span class='highlight "+ title +"'>" +
          innerHTML.substring(
            lastIndex + index,
            lastIndex + index + searchTerm.length
          ) +
          "</span>";
        lastIndex = lastIndex + index + searchTerm.length;
      }
    } while (index > -1);
    newInnerHTML = newInnerHTML + innerHTML.substring(lastIndex);
    
    if(title != "none"){
      article.getElementsByTagName("A")[0].innerHTML = newInnerHTML;
    
    } else {
      article.innerHTML = newInnerHTML;
    }
    article.classList.add("image-show");
  }
}

function pageChangeSearch() {
  input = history.state.searchParams;
  filter = history.state.filter;

  var filteredArray = [];
  var filteredTitleArray = [];
  var filteredContentArray = [];
  var filteredTags = [];
  if (input != "" && input != " ") {
    var searchPrompt = document.getElementById("blogSearchPrompt");
    document.getElementsByClassName("recommendationBarDiv")[0].style.display =
      "none";
    document.getElementsByClassName(
      "searchBarContainer"
    )[0].style.backgroundColor = "transparent";
    document.getElementsByClassName("searchClearIcon")[0].style.display =
      "block";
    for (let i = 0; i < articlesArray.length; i++) {
      filteredTags.push(...articlesArray[i].tags);
      var articleName = articlesArray[i].title;
      
      var articleContent = purgeArticleContent(articlesArray[i].content)
        ? purgeArticleContent(articlesArray[i].content)
        : articlesArray[i].content_trunc;
      var articleTags = articlesArray[i].tags;
      var matchIndex = articleTags.findIndex((element) => {
        var elementTag = element
          .toUpperCase()
          .replace("_related:", "")
          .replace("-", " ");
        if (elementTag.indexOf(input) > -1) {
          return true;
        }
      });
      if (articleName.toUpperCase().indexOf(input) > -1) {
        var thisArticle = JSON.parse(JSON.stringify(articlesArray[i]));
        thisArticle.content_trunc = articleContent;
        filteredTitleArray.push(thisArticle);
      } else if (
        articleContent.toUpperCase().indexOf(input) > -1 ||
        matchIndex > -1
      ) {
        var thisArticle = JSON.parse(JSON.stringify(articlesArray[i]));
        thisArticle.content_trunc = articleContent;
        filteredContentArray.push(thisArticle);
      }
    }
    filteredContentArray.sort(function (a, b) {
      return b["updated"] - a["updated"];
    });
    filteredTitleArray.sort(function (a, b) {
      return b["updated"] - a["updated"];
    });
    filteredArray = filteredTitleArray.concat(filteredContentArray);
    var uniqueTags = [...new Set(filteredTags)];
    for (let i = 0; i < uniqueTags.length; i++) {
      var tag = uniqueTags[i];
      var tagName = tag.replace("_related:", "");
      var words = tagName.split("-");
      for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
      }
      if (words[0].includes("nti")) {
        tagName = words.join("-");
      } else {
        tagName = words.join(" ");
      }
      if (
        tagName.toUpperCase().startsWith(input) &&
        tagName.toUpperCase().indexOf(input) > -1 &&
        tagName.toUpperCase() != input
      ) {
        searchPrompt.value = tagName;
        document.getElementsByClassName(
          "recommendationBarDiv"
        )[0].style.display = "flex";
        document.getElementsByClassName(
          "searchBarContainer"
        )[0].style.backgroundColor = "#e5e5e5";
      }
    }
    blogDisplayArticles(filteredArray, input);
  } else if (filter != "") {
    var filteredArray = [];
    var filters = document.getElementsByClassName("filter_tag");
    for (let i = 0; i < filters.length; i++) {
      filters[i].style.backgroundColor = "#e5e5e5";
      removeBorder(filters[i]);
      filters[i].style.boxShadow = "none";
      filters[i].onmouseleave = "filterOut('" + filters[i].id + "')";
      filters[i].href = "/blogs/health?filter=" + filters[i].id;
    }
    var tagName =
      "_related:" +
      stateFilter
        .replace(/%20/g, "-")
        .replace(/ /g, "-")
        .replace(/%27/g, "'")
        .replace(/%26/g, "&")
        .toLowerCase();
    if (tagName == "_related:adhd") {
      tagName = "_related:ADHD";
    }
    if (tagName == "_related:ibs") {
      tagName = "_related:IBS";
    }

    if (tagName == "_related:pms-relief") {
      tagName = "_related:PMS-relief";
    }

    if (tagName == "_related:uti") {
      tagName = "_related:UTI";
    }
    if (tagName == "_related:cold-&-flu") {
      tagName = "_related:Cold-&-Flu";
    }
    var filter = document.getElementById(stateFilter);

    if (filter != null && filter != undefined) {
      //var filterColour = filter.getElementsByTagName('span')[0].style.color;
      var filterColour = filter.dataset.color;
      filter.style.border = `2px solid ${filterColour}`;
     // filter.style.backgroundColor = hexToRGB(filterColour, 0.25); //filterColour.replace(')', ', 0.25)').replace('rgb', 'rgba');

      filter.style.boxShadow = "0px 5px 10px rgba(0, 0, 0, 0.25)";
      filter.onmouseleave = null;
      filter.href = "/blogs/health";
    } else {
      if (AddFilterTag == true || tagAdd == true) {
        var filter = document.getElementById("custom");
        var filterColour = "";
        var colourIndex = tagNames.indexOf(tagName);
        if (colourIndex != -1) {
          filterColour = tagColours[colourIndex];
        } else {
          var randomColourIndex = extraTags.indexOf(tagName);
          filterColour = randomColours[randomColourIndex];
        }

        var filterText = stateFilter
          .replace(/%20/g, " ")
          .replace(/%27/g, "'")
          .replace(/%26/g, "&");
        var filterColourAlpha = hexToRGB(filterColour, 0.25);
       // filter.getElementsByTagName("span")[0].style.color = filterColour;
       // filter.style.backgroundColor = filterColourAlpha;
   
    filter.style.border = `2px solid ${filterColour}`;
        filter.onmouseover = function(){
          filterHover('custom', filterColour);
        };
        filter.onmouseout = function(){
          filterOut('custom');
        };
        filter.style.boxShadow = "0px 5px 10px rgba(0, 0, 0, 0.25)";
        document.getElementById("custom-tag-text").innerText = filterText;
        if (filter.classList.contains("hidden-tag")) {
          filter.classList.remove("hidden-tag");
        }
        filter.classList.remove("hidden-tag");
      }
    }
    for (let j = 0; j < articlesArray.length; j++) {
      if (articlesArray[j].tags.includes(tagName) || tagName == "") {
        filteredArray.push(articlesArray[j]);
      }
    }
    if (AddFilterTag == false) {
      filteredArray.sort(function (a, b) {
        return b["updated"] - a["updated"];
      });
    }
    blogDisplayArticles(filteredArray);
  } else {
    blogDisplayArticles(articlesArray);
  }
}
clearsearchfilter = function () {
  input = "";
  stateInput = "";
  currentPage = 1;
  statePage = currentPage;
  var searchPrompt = document.getElementById("blogSearchPrompt");
  document.getElementsByClassName("recommendationBarDiv")[0].style.display =
    "none";
  document.getElementsByClassName(
    "searchBarContainer"
  )[0].style.backgroundColor = "transparent";
  document.getElementById("blogSearchBar").value = "";
  document.getElementsByClassName("searchClearIcon")[0].style.display = "none";
   if (stateFilter != "") {
    noFilter();
  }
}
clearSearchInput = function () {
  const PageBtn = document.getElementById("articles");
  PageBtn.innerHTML = "";
  input = "";
  stateInput = "";
  currentPage = 1;
  statePage = currentPage;
  var searchPrompt = document.getElementById("blogSearchPrompt");
  document.getElementsByClassName("recommendationBarDiv")[0].style.display =
    "none";
  document.getElementsByClassName(
    "searchBarContainer"
  )[0].style.backgroundColor = "transparent";
  document.getElementById("blogSearchBar").value = "";
  document.getElementsByClassName("searchClearIcon")[0].style.display = "none";
  if (stateFilter != "") {
    noFilter();
  }
  var customFilter = document.getElementById("custom");
  if (!customFilter.classList.contains("hidden-tag")) {
    customFilter.classList.add("hidden-tag");
    stateFilter = "";
    filter = "";
  }
  
  var stateObj = {
    searchParams: stateInput,
    filter: stateFilter,
    page: statePage,
  };
  history.pushState(stateObj, "Illuminate Health");
  blogDisplayArticles(articlesArray);
};
pushHistoryState = function (page) {
  var stateObj = {
    searchParams: input,
    filter: stateFilter,
    page: page,
  };
  history.pushState(stateObj, "Illuminate Health");
  currentPage = history.state.page;
  filter = history.state.filter;
  pageChangeSearch();
  // window.scrollTo({top: 0, behavior: 'smooth'});
  return false;
};
function filterWidth() {
  var choices = document.querySelectorAll(".visible_tag");
  var maxWidth = 0;
  for (i = 0; i < choices.length; ++i) {
    maxWidth = Math.max(maxWidth, choices[i].offsetWidth);
  }
  for (i = 0; i < choices.length; ++i) {
    choices[i].style.width = maxWidth + "px";
  }
}
$(document).ready(function () {
  var filters = document.getElementsByClassName("filter_tag");
  var queryString = window.location.search;
  var urlParams = new URLSearchParams(queryString);
  stateInput = "";

  if (urlParams.has("filter")) {
    var filterApplied = urlParams.get("filter");

    var filter = document.getElementById(filterApplied);
    stateFilter = "";
    // filter.click();

    var stateObj = {
      searchParams: stateInput,
      filter: filterApplied,
      page: statePage,
    };
    filterSelected(filterApplied);
    filterWidth();
    window.history.replaceState(stateObj, "Illuminate Health", "/blogs/health");
  } else {
    noFilter();
    filterWidth();
    clearSearchInput();
    // blogDisplayArticles(articlesArray);
  }

  document.querySelector('.searchBarContainer').classList.add("loaded");
  
  // Load remaining articles if needed (fallback for document ready)
  if (window.totalArticlesNeeded && window.loadedArticlesCount) {
    if (window.loadedArticlesCount < window.totalArticlesNeeded) {
      loadRemainingArticles(window.loadedArticlesCount, window.totalArticlesNeeded);
    }
  }
});

// Function to load remaining articles via AJAX with higher limits
function loadRemainingArticles(startIndex, totalArticles) {
  // Calculate how many more articles we need
  var remainingArticles = totalArticles - articlesArray.length;
  
  if (remainingArticles <= 0) {
    return;
  }
  
  // Try to load 250 articles per request (higher limit)
  var articlesPerRequest = 250;
  var currentPage = Math.floor(articlesArray.length / articlesPerRequest) + 1;
  var totalRequests = Math.ceil(remainingArticles / articlesPerRequest);
  
  function loadNextBatch() {
    if (currentPage > totalRequests + 1) {
      console.log('=== FINAL DEBUG ===');
      console.log('All articles loaded. Final total:', articlesArray.length);
      // for (var i = 0; i < Math.min(5, articlesArray.length); i++) {
      //   console.log(i + 1 + '.', articlesArray[i].title);
      // }
      console.log('=== END DEBUG ===');
      return;
    }
    
    var url = '/blogs/health?page=' + currentPage + '&limit=' + articlesPerRequest;
    
    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok: ' + response.status);
        }
        return response.text();
      })
      .then(html => {
        // Parse the HTML to extract article data
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        
        // Look for script tags that contain article data
        var scripts = doc.querySelectorAll('script');
        var articlesFound = 0;
        
        for (var i = 0; i < scripts.length; i++) {
          var scriptContent = scripts[i].textContent;
          if (scriptContent.includes('var articleObject = {')) {
            // Extract all articleObject definitions
            var articleMatches = scriptContent.match(/var articleObject = \{[\s\S]*?\};/g);
            if (articleMatches) {
              for (var j = 0; j < articleMatches.length; j++) {
                try {
                  // Clean the string to make it a valid JavaScript object
                  var cleanStr = articleMatches[j].replace('var articleObject = ', '').replace(/;$/, '');
                  
                  try {
                    // Evaluate the cleanStr as a JavaScript object
                    var articleObj = eval('(' + cleanStr + ')');
                    
                    // Check if article already exists
                    var exists = articlesArray.some(a => a.url === articleObj.url);
                    if (!exists) {
                      articlesArray.push(articleObj);
                      articlesFound++;
                    }
                  } catch (e) {
                    // Silent error handling
                  }
                } catch (e) {
                  // Silent error handling
                }
              }
            }
            break;
          }
        }
        
        currentPage++;
        
        // Continue with next batch
        setTimeout(loadNextBatch, 100); // Small delay between requests
      })
      .catch(error => {
        currentPage++;
        setTimeout(loadNextBatch, 100);
      });
  }
  
  loadNextBatch();
}
